import { PlansResponse } from '../../types';
import axiosInstance from '../../utils/axiosInstance';

export const fetchClientsPlansList = async (
  pageIndex: number,
  pageSize: number,
  searchString: string,
  orderDirection: 'asc' | 'desc' | '',
): Promise<PlansResponse> => {
  try {
    const response = await axiosInstance.post('/Admin/GetClientsPlansList', {
      pageIndex,
      pageSize,
      searchString,
      orderDirection,
    });
    return response.data as PlansResponse;
  } catch (error) {
    console.error('Error fetching active clients plans:', error);
    throw error;
  }
};

export const fetchClientsPlanRequestsList = async (
  pageIndex: number,
  pageSize: number,
  searchString: string,
  orderDirection: 'asc' | 'desc' | '',
): Promise<PlansResponse> => {
  try {
    const response = await axiosInstance.post(
      '/Admin/GetClientsPlanRequestsList',
      {
        pageIndex,
        pageSize,
        searchString,
        orderDirection,
      },
    );
    return response.data as PlansResponse;
  } catch (error) {
    console.error('Error fetching client plan requests:', error);
    throw error;
  }
};

// Деактивація тарифу клієнта: бекенд виставляє PlanId = null для цього клієнта.
export const removeClientPlan = async (clientId: string): Promise<void> => {
  try {
    await axiosInstance.delete('/Admin/RemoveClientPlan', {
      params: { clientId },
    });
  } catch (error) {
    console.error('Error removing client plan:', error);
    throw error;
  }
};

// Відхилення (видалення) заявки на тариф.
export const removePlanRequest = async (
  requestPlanId: string,
): Promise<void> => {
  try {
    await axiosInstance.delete('/Admin/RemovePlanRequest', {
      params: { requestPlanId },
    });
  } catch (error) {
    console.error('Error removing plan request:', error);
    throw error;
  }
};

// #29: CRUD визначень тарифів (Free/Standard/… як редаговані записи).
export interface PlanDefinition {
  id: number;
  name: string;
  isActive: boolean;
}

export const fetchAllPlanDefinitions = async (): Promise<PlanDefinition[]> => {
  const response = await axiosInstance.get('/Plans/GetAllPlans');
  return response.data as PlanDefinition[];
};

export const createPlanDefinition = async (
  name: string,
): Promise<PlanDefinition> => {
  const response = await axiosInstance.post('/Plans/CreatePlan', { name });
  return response.data as PlanDefinition;
};

export const editPlanDefinition = async (
  id: number,
  name: string,
  isActive: boolean,
): Promise<PlanDefinition> => {
  const response = await axiosInstance.put('/Plans/EditPlan', {
    id,
    name,
    isActive,
  });
  return response.data as PlanDefinition;
};

export const deletePlanDefinition = async (id: number): Promise<void> => {
  await axiosInstance.delete('/Plans/DeletePlan', {
    params: { planId: id },
  });
};
